import React, { useState } from "react";
import API from "../../api/axiosConfig";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";

export default function ChangePasswordForm({ onCancel }) {
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirm: "",
  });

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (key, val) => {
    setForm((f) => ({ ...f, [key]: val }));
  };

  const submit = async () => {
    if (!form.currentPassword || !form.newPassword || !form.confirm) {
      toast.warn("Completa todos los campos");
      return;
    }

    if (form.newPassword !== form.confirm) {
      toast.error("Las contraseñas no coinciden");
      return;
    }

    try {
      setLoading(true);
      await API.put("/users/me/password", {
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });

      toast.success("Contraseña actualizada");
      onCancel();
    } catch (err) {
      toast.error(err.response?.data?.msg || "Error actualizando contraseña");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4 py-2">
      <div>
        <label className="text-sm font-medium">Contraseña actual</label>
        <input
          type={show ? "text" : "password"}
          className="w-full mt-2 p-3 rounded-xl border"
          value={form.currentPassword}
          onChange={(e) => handleChange("currentPassword", e.target.value)}
        />
      </div>

      <div>
        <label className="text-sm font-medium">Nueva contraseña</label>
        <input
          type={show ? "text" : "password"}
          className="w-full mt-2 p-3 rounded-xl border"
          value={form.newPassword}
          onChange={(e) => handleChange("newPassword", e.target.value)}
        />
      </div>

      <div>
        <label className="text-sm font-medium">
          Confirmar nueva contraseña
        </label>
        <input
          type={show ? "text" : "password"}
          className="w-full mt-2 p-3 rounded-xl border"
          value={form.confirm}
          onChange={(e) => handleChange("confirm", e.target.value)}
        />
      </div>

      <button
        type="button"
        onClick={() => setShow(!show)}
        className="flex items-center gap-2 text-sm text-gray-600"
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
        {show ? "Ocultar contraseñas" : "Mostrar contraseñas"}
      </button>

      <div className="flex justify-end gap-2 mt-4">
        <button onClick={onCancel} className="px-4 py-2 rounded-xl border">
          Cancelar
        </button>
        <button
          onClick={submit}
          disabled={loading}
          className="px-4 py-2 rounded-xl bg-supernova-500 text-white"
        >
          {loading ? "Guardando..." : "Actualizar"}
        </button>
      </div>
    </div>
  );
}
